<!-- 舱单日志弹窗 -->
<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('SeaExport.manifestQueryLog')"
    width="600px"
    :close-on-click-modal="false"
  >
    <cargo-ag-grid
      :grid-options="gridOptions"
      :column-defs="isSeaHouseChannel ? housekeeper : columnDefs"
      :grid-params.sync="gridParams"
      :row-data="rowData"
      style="width:100%;height:300px"
      @gridReady="onGridReady"
    />
    <span slot="footer">
      <el-button @click="innerVisible=false">{{ $t('common.btn.close') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>

import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { cacheName, cache } from '@/utils/cacheManager'
import ColumnUtils from '@/utils/ColumnUtils'
import { queryManifestCfmLog } from '@/api/seaExport/manifestInfo'
import URL from '@/api/urlTranslator'

export default {
  name: 'ManifestInfoLogDialog',
  components: { },
  props: {
    visible: { type: Boolean, required: true },
    manifestInfoUuid: { type: String, required: true },
    isSeaHouseChannel: { type: Boolean, required: true }
  },
  data() {
    return {
      innerVisible: false,
      storageURL: '',
      gridOptions: {
        rowSelection: 'single',
        suppressCellSelection: true,
        defaultColDef: {
          resizable: true
        },
        context: {
          componentParent: this
        }
      },
      gridParams: {},
      housekeeper: [
        {
          headerName: this.$t('SeaExport.SoNo'),
          field: 'SO_NO',
          width: 130
        },
        {
          headerName: this.$t('SeaExport.operationTime'),
          field: 'DATE_CREATED',
          width: 139
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperateBy'),
          field: 'CREATED_BY',
          width: 110,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.operationalMotion'),
          field: 'CONTENT',
          width: 110
        },
        {
          headerName: this.$t('SeaExport.Operation'), field: 'FILE_ID', colId: 'FILE_ID', width: 150, noExport: true,
          cellRenderer: (params) => {
            if (params.value) {
              return `<a href="${URL.common.findByFileId}/${params.value}?sessionId=${this.$store.getters.token}" target="_blank" style="color:blue">${this.$t('FileHistory.fileDownload')}</a>`
            } else {
              return ''
            }
          }
        }
      ],
      columnDefs: [
        {
          headerName: this.$t('SeaExport.SoNo'),
          field: 'SO_NO',
          width: 130
        },
        {
          headerName: this.$t('CargoMsg.Cargo_Time'),
          field: 'DATE_CREATED',
          width: 139
        }, {
          headerName: this.$t('CargoMsg.Cargo_OperateBy'),
          field: 'CREATED_BY',
          width: 110,
          cellRenderer: params => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
          }
        }, {
          headerName: this.$t('SeaExport.Content'),
          field: 'CONTENT',
          width: 231
        }
      ],
      rowData: [],
      gridApi: null
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.toQuery()
    }
  },
  methods: {
    onGridReady(params) {
      this.gridApi = params.api
    },
    toQuery() {
      this.storageURL = cache.config.get('StorageURL')
      if (this.manifestInfoUuid) {
        queryManifestCfmLog({ manifestInfoUuid: this.manifestInfoUuid }).then(res => {
          this.rowData = res.data
        })
      } else {
        this.rowData = []
      }
    }
  }
}
</script>

<style>
</style>
